// // main.ts
// if (typeof window !== 'undefined') {
//   const startHydration = async () => {
//     const { bootstrap } = await import('./main-app');
//     await bootstrap();
//   };

//   if ('requestIdleCallback' in window) {
//     // Defer hasta que el navegador esté libre
//     (window as any).requestIdleCallback(startHydration);
//   } else {
//     // Fallback por compatibilidad
//     setTimeout(startHydration, 300);
//   }
// }

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));